import { render, staticRenderFns } from "./articleheader.vue?vue&type=template&id=a2d4576e&"
import script from "./articleheader.vue?vue&type=script&lang=js&"
export * from "./articleheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports